import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import {
  Col,
  Button,
  Row,
  ControlLabel
} from 'react-bootstrap';

const UserSelectorComponent = ({
  loading,
  loggedIn,
  onCredentialsChange,
  onLogoutClick
}) => (
  <div>
    {
      !loading && !loggedIn ?
        <div>
          <Row style={{ 'color': 'red' }}>
            <Col md={10} mdOffset={1}>
              <ControlLabel>Login</ControlLabel>
            </Col>
          </Row>
          <LocalForm
            className="login-form"
            onSubmit={onCredentialsChange}
            initialState={{
              username: '',
              password: ''
            }}
          >
            <Row>
              <Col md={4} mdOffset={1}>
                <Control.text
                  className="form-control"
                  placeholder="Username"
                  model=".username"
                />
              </Col>
              <Col md={4}>
                <Control
                  className="form-control"
                  type="password"
                  placeholder="Password"
                  model=".password"
                />
              </Col>
              <Col md={2}>
                <Button
                  bsStyle="info"
                  className="form-control"
                  type="submit"
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </LocalForm>
        </div> :
        loggedIn ?
          <div>
            <Row>
              <ControlLabel style={{ 'color': 'green', padding: '30px 0 0 30px' }}>
                Logged In
              </ControlLabel>
              <ControlLabel style={{ padding: '0 0 0 20px' }}>
                <Button
                  id="button-logout"
                  onClick={onLogoutClick}
                >
                  Log Out
                </Button>
              </ControlLabel>
            </Row>
          </div> :
          <ControlLabel style={{ padding: '15px 0 0 15px', fontStyle: 'italic' }}>
            Loading...
          </ControlLabel>
    }
  </div>
);

UserSelectorComponent.propTypes = {
  loading: PropTypes.bool,
  loggedIn: PropTypes.bool,
  onCredentialsChange: PropTypes.func.isRequired,
  onLogoutClick: PropTypes.func.isRequired
};

export default UserSelectorComponent;


// WEBPACK FOOTER //
// src/Components/UserSelectorComponent.jsx